module.exports = __webpack_public_path__ + "static/media/ic-mob-emails.ba392a59.svg";